import PlayersDashboardNotFoundError from './players-dashboard-not-found-error';
import {PlayersDashboard as DraftkingsGolfPlayersDashboard} from 'desktop/sites/draftkings/golf/players-dashboard';
import {PlayersDashboard as DraftkingsF1PlayersDashboard} from 'desktop/sites/draftkings/f1/players-dashboard';
import {PlayersDashboard as DraftkingsNbaPlayersDashboard} from 'desktop/sites/draftkings/nba/players-dashboard';
import {PlayersDashboard as DraftkingsNflPlayersDashboard} from 'desktop/sites/draftkings/nfl/players-dashboard';
import {PlayersDashboard as DraftkingsMlbPlayersDashboard} from 'desktop/sites/draftkings/mlb/players-dashboard';
import {PlayersDashboard as DraftkingsNascarPlayersDashboard} from 'desktop/sites/draftkings/nascar/players-dashboard';
import {PlayersDashboard as DraftkingsMmaPlayersDashboard} from 'desktop/sites/draftkings/mma/players-dashboard';
import {PlayersDashboard as DraftkingsNhlPlayersDashboard} from 'desktop/sites/draftkings/nhl/players-dashboard';
import {PlayersDashboard as DraftkingsCfbPlayersDashboard} from 'desktop/sites/draftkings/cfb/players-dashboard';
import {PlayersDashboard as DraftkingsLolPlayersDashboard} from 'desktop/sites/draftkings/lol/players-dashboard';
import {PlayersDashboard as FanduelGolfPlayersDashboard} from 'desktop/sites/fanduel/golf/players-dashboard';
import {PlayersDashboard as FanduelNbaPlayersDashboard} from 'desktop/sites/fanduel/nba/players-dashboard';
import {PlayersDashboard as FanduelNflPlayersDashboard} from 'desktop/sites/fanduel/nfl/players-dashboard';
import {PlayersDashboard as FanduelMlbPlayersDashboard} from 'desktop/sites/fanduel/mlb/players-dashboard';
import {PlayersDashboard as FanduelNascarPlayersDashboard} from 'desktop/sites/fanduel/nascar/players-dashboard';
import {PlayersDashboard as FanduelNhlPlayersDashboard} from 'desktop/sites/fanduel/nhl/players-dashboard';
import {PlayersDashboard as FanduelCfbPlayersDashboard} from 'desktop/sites/fanduel/cfb/players-dashboard';
import {PlayersDashboard as FanduelMmaPlayersDashboard} from 'desktop/sites/fanduel/mma/players-dashboard';
import {PlayersDashboard as FanduelLolPlayersDashboard} from 'desktop/sites/fanduel/lol/players-dashboard';
import {PlayersDashboard as YahooNflPlayersDashboard} from 'desktop/sites/yahoo/nfl/players-dashboard';
import {PlayersDashboard as DraftkingsTennisPlayersDashboard} from 'desktop/sites/draftkings/tennis/players-dashboard';

const dashboardMap = {
    draftkings: {
        cfb: DraftkingsCfbPlayersDashboard,
        f1: DraftkingsF1PlayersDashboard,
        golf: DraftkingsGolfPlayersDashboard,
        lol: DraftkingsLolPlayersDashboard,
        mlb: DraftkingsMlbPlayersDashboard,
        mma: DraftkingsMmaPlayersDashboard,
        nascar: DraftkingsNascarPlayersDashboard,
        nba: DraftkingsNbaPlayersDashboard,
        nfl: DraftkingsNflPlayersDashboard,
        nhl: DraftkingsNhlPlayersDashboard,
        tennis: DraftkingsTennisPlayersDashboard,
    },
    fanduel: {
        cfb: FanduelCfbPlayersDashboard,
        golf: FanduelGolfPlayersDashboard,
        lol: FanduelLolPlayersDashboard,
        mlb: FanduelMlbPlayersDashboard,
        mma: FanduelMmaPlayersDashboard,
        nascar: FanduelNascarPlayersDashboard,
        nba: FanduelNbaPlayersDashboard,
        nfl: FanduelNflPlayersDashboard,
        nhl: FanduelNhlPlayersDashboard,
    },
    yahoo: {
        nfl: YahooNflPlayersDashboard,
    },
};

const PlayersDashboardFactory = {
    getComponent(sportConfig) {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();

        try {
            return dashboardMap[site][sport].get(sportConfig);
        } catch (e) {
            if (e instanceof TypeError) {
                throw new PlayersDashboardNotFoundError(`Undefined Player's Dashboard for ${site}/${sport}`);
            }
            throw e;
        }
    },
};

export default PlayersDashboardFactory;
